import 'react';
import { ToggleLabel, ToggleInput } from './styles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const Toggle = ({
  checked,
  disabled,
  onChange,
  'aria-label': ariaLabel,
  'data-testid': testId,
  ...spacingProps
}) => jsx(ToggleLabel, {
  "aria-label": ariaLabel,
  "data-testid": testId,
  ...spacingProps,
  children: jsx(ToggleInput, {
    checked: checked,
    "data-testid": `${testId}-input`,
    disabled: disabled,
    onChange: onChange,
    type: "checkbox"
  })
});

export { Toggle };
